"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const detect_browser_1 = require("detect-browser");
const KImage = (_a) => {
    var { src, innerRef, maxSize } = _a, rest = __rest(_a, ["src", "innerRef", "maxSize"]);
    const [loaded, setLoaded] = (0, react_1.useState)(0);
    const [tempImg, setTempImg] = (0, react_1.useState)('');
    const [isSafari, hasWindowOrDocument] = (0, react_1.useMemo)(() => {
        const browser = (0, detect_browser_1.detect)();
        return [(browser === null || browser === void 0 ? void 0 : browser.name) !== 'safari', typeof window === 'undefined' || typeof document === 'undefined'];
    }, [window, document]);
    (0, react_1.useEffect)(() => {
        if (!src || hasWindowOrDocument || isSafari) {
            return;
        }
        setLoaded(0);
        setTempImg('');
        const image = new Image();
        image.src = src;
        image.decoding = 'sync';
        image.onload = () => {
            const max = Math.max(image.width, image.height);
            if (maxSize && maxSize < max) {
                fetch(src)
                    .then((res) => {
                    return res.blob();
                })
                    .then(async (blob) => {
                    var _a;
                    const { readAndCompressImage } = await Promise.resolve().then(() => require('browser-image-resizer'));
                    const ext = (_a = src.split('.').reverse()) === null || _a === void 0 ? void 0 : _a[0].toLowerCase();
                    const img = new File([blob], `temp.${ext}`);
                    const config = {
                        maxHeight: maxSize,
                        maxWidth: maxSize,
                        quality: 1,
                        mimeType: ext === 'jpg' ? 'image/jpeg' : 'image/png',
                    };
                    return readAndCompressImage(img, config).then((resizedBlob) => {
                        return URL.createObjectURL(resizedBlob);
                    });
                })
                    .then((resizedImg) => {
                    setTempImg(resizedImg);
                    setLoaded(2);
                })
                    .catch(() => {
                    setLoaded(1);
                });
            }
            else {
                setLoaded(1);
            }
        };
        image.onerror = (err) => {
            console.log('KImage', err);
            setLoaded(1);
        };
        return () => {
            if (tempImg) {
                URL.revokeObjectURL(tempImg);
            }
            image.remove();
        };
    }, [src]);
    if (hasWindowOrDocument || isSafari) {
        return (0, jsx_runtime_1.jsx)("img", Object.assign({}, rest, { alt: rest.alt || '', src: src, ref: innerRef, decoding: "sync" }));
    }
    if (!loaded) {
        return null;
    }
    const props = Object.assign(Object.assign({}, rest), { ref: innerRef, style: {
            backgroundImage: `url("${src}")`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        } });
    if (loaded === 2) {
        return (0, jsx_runtime_1.jsx)("img", Object.assign({}, props, { src: tempImg, alt: `resized-${rest.alt || ''}` }));
    }
    return (0, jsx_runtime_1.jsx)("img", Object.assign({}, props, { alt: rest.alt || '', src: src, decoding: "sync" }));
};
exports.default = KImage;
